exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".t-tooltip .tooltip-inner{min-height:28px;font-size:14px;line-height:20px;font-weight:600;opacity:.7}.t-tooltip.tooltip .arrow{display:none}", ""]);

// exports
